import { IQuestion, QuestionCategories, QuestionType } from "@sp-crm/core";

function isRenderableTypeQuestion(question: IQuestion): boolean {
    return (
        question.questionType === QuestionType.binary ||
        question.questionType === QuestionType.nary
    );
}

export function getFirstTypeFilterQuestion(
    questions: IQuestion[],
): IQuestion | undefined {
    const order = (questionA: IQuestion, questionB: IQuestion): number =>
        (questionA.order || 0) - (questionB.order || 0);
    return (questions || [])
        .filter(
            q => q.category === QuestionCategories.type && isRenderableTypeQuestion(q),
        )
        .sort(order)[0];
}
